import { Component, OnInit, Input, Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { cloneArray } from 'src/app/app.component';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css']
})
export class RadioComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() controlName;
  @Input() options;
  @Input() label;
  @Input() value;
  @Input() required;
  @Input() label_block;
  @Input() disabled;
  constructor() { }

  ngOnInit() {
    console.log(this.label_block);
    this.options = cloneArray(this.options);
  }

}
